module.exports = __webpack_public_path__ + "static/img/ble.cabba5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ble.jpg
// module id = 262
// module chunks = 1